import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import { bottlings, casingWines, conciergerieTypesRequest, listWineTypes, wineRarities, listContinents, tenantType } from "@/js/lists.ts";
import { request } from "@/js/http/http_request";
import { hasRole, isUserBuyerGroup, isAdminNotConsultant, isConsultantOrHolding, isHolding, isIndividual } from "@/js/http/auth.js";
import { hasAccessGranted } from "@/js/user/user.js";
import { wineNaming, casingForAdmin } from "@/js/wine/wine.js";
import { displayPrice } from "@/js/currency/currencies.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import RatingComponent from "@/components/rating/RatingComponent.vue";
import WineAddCartButton from "@/components/products/WineAddCartButton.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import WineDiscountTooltip from "@/components/products/WineDiscountTooltip.vue";
import WineRangeAccessibility from "@/components/products/WineRangeAccessibility.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "AssociateWineCard",
  props: {
    wineProp: Object,
    isAddingToCart: Array,
    loggedUserData: Object,
    wineCard: {
      type: Object,
      default: function _default() {
        return {
          displaySkuInsteadOfPrice: false
        };
      }
    }
  },
  components: {
    "wine-add-cart-btn": WineAddCartButton,
    "wine-naming": WineNaming,
    rating: RatingComponent,
    WineDiscountTooltip: WineDiscountTooltip,
    WineRangeAccessibility: WineRangeAccessibility,
    Confirm: Confirm
  },
  data: function data() {
    return {
      wine: null,
      discountAmount: 0,
      caseNumber: 1,
      bottlings: bottlings,
      casingIdSelected: "",
      casingWines: casingWines,
      listWineTypes: listWineTypes,
      wineRaritiesValues: Object.values(wineRarities),
      listContinents: listContinents,
      tenantType: tenantType,
      filterIntegerKey: filterIntegerKey,
      isImageBroken: false,
      refreshWineAccess: false,
      isGrantedAccessibility: false
    };
  },
  computed: {
    routerLinkConciergerie: function routerLinkConciergerie() {
      return {
        name: "userConciergerie",
        query: {
          message: "I would like informations about the availability of the following product " + wineNaming(this.$whitelabel, this.wine.naming_data, true, true),
          conciergerieType: conciergerieTypesRequest.find(function (x) {
            return x.text == "Specific product and/or vintage";
          }).contact_type
        }
      };
    },
    canPurchaseWine: function canPurchaseWine() {
      return this.isGrantedAccessibility || hasRole(process.env.VUE_APP_ROLES_BYPASS_RANGE_ACCESSIBILITY);
    },
    canManageWine: function canManageWine() {
      return isAdminNotConsultant(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_WINE_ADMIN);
    },
    isSoldOutDisplayed: function isSoldOutDisplayed() {
      var _this2 = this;
      if (isAdminNotConsultant(this.loggedUserData) && this.wine.stocks.length === 0) {
        return true;
      }
      return !isAdminNotConsultant(this.loggedUserData) && (!this.wine.stock_quantity || !this.wine.casings.some(function (wc) {
        return _this2.wine.stock_quantity >= wc.quantity;
      }));
    },
    isStockIncompatible: function isStockIncompatible() {
      return isAdminNotConsultant(this.loggedUserData) && this.wine.stock_quantity === 0 && this.wine.stocks.length > 0 && this.wine.stocks.some(function (ws) {
        return ws.stock_quantity > 0;
      });
    },
    casingsAvailable: function casingsAvailable() {
      return this.wine.casings;
    }
  },
  created: function created() {
    var _this3 = this;
    this.wine = _objectSpread(_objectSpread({}, this.wineProp), {}, {
      casings: this.wineProp.casings.map(function (wc) {
        if (wc.quantity <= _this3.wineProp.stock_quantity) {
          if (!_this3.casingIdSelected || wc.isDefault) {
            _this3.casingIdSelected = wc.casingId;
          }
        }
        return _objectSpread(_objectSpread({}, wc), {}, {
          textCard: casingWines.find(function (x) {
            return x.value == wc.casingId;
          }).textCard
        });
      })
    });
    this.wine.casings.sort(function (a, b) {
      return a.quantity - b.quantity;
    });
    if (isAdminNotConsultant(this.loggedUserData) && !this.wine.casings.some(function (x) {
      return x.quantity == 1;
    })) {
      this.wine.casings.unshift(casingForAdmin());
      if (!this.casingIdSelected) {
        this.casingIdSelected = this.wine.casings[0].casingId;
      }
    }
    if (!this.casingIdSelected) {
      this.casingIdSelected = this.wineProp.casings.find(function (x) {
        return x.isDefault;
      }).casingId;
    }
    this.isGrantedAccessibility = hasAccessGranted(this.wine.rangeAccessibility);
    this.$EventBus.$on("refresh_category_user", function (value) {
      _this3.isGrantedAccessibility = hasAccessGranted(_this3.wine.rangeAccessibility);
    });
  },
  methods: {
    productDetails: function productDetails(wine) {
      var isEdit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var detailsRoute = "";
      var routeParams = {};
      var query = {};
      if (this.loggedUserData.userGroup === "ADMIN") {
        routeParams = {
          searchCriterias: _objectSpread({}, this.searchCriterias)
        };
        detailsRoute = wine.type == listWineTypes.find(function (x) {
          return x.name === "Spirit";
        }).id ? "adminSpiritsDetails" : "adminWineDetails";
      } else {
        detailsRoute = wine.type == listWineTypes.find(function (x) {
          return x.name === "Spirit";
        }).id ? "userSpiritsDetails" : "userWineDetails";
        routeParams = {
          searchCriterias: _objectSpread({}, this.searchCriterias)
        };
      }
      if (!wine.id_wine || isEdit) query = {
        edit: true
      };
      return {
        name: detailsRoute,
        query: query,
        params: {
          id: wine.id_wine || "new",
          searchCriterias: this.searchCriterias,
          routeParam: routeParams
        }
      };
    },
    isBuyer: function isBuyer() {
      return hasRole(process.env.VUE_APP_ROLES_BUYER) || hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
    },
    toggleFavorite: function toggleFavorite(wine) {
      wine.favorite = !wine.favorite;
      var _this = this;
      // Save the order serverside before saving it in the local storage
      request("/v1/user/favorites/" + wine.id_wine + "?isWineToAdd=" + wine.favorite, "put", null, true, "api").then(function (response) {
        if (wine.favorite) {
          _this.$toasted.show("Product added to your favorites.", {
            type: "success"
          });
        } else {
          _this.$toasted.show("Product removed from your favorites.", {
            type: "success"
          });
        }
      });
    },
    getStatusAvailabilityClass: function getStatusAvailabilityClass() {
      var _this4 = this;
      if (isAdminNotConsultant(this.loggedUserData) && this.wine.stock_quantity < this.casingIdSelected.match(/\d+/)[0]) {
        return "--unavailable";
      }
      return this.wineRaritiesValues.find(function (x) {
        return x.id == _this4.wine.rarity;
      }).stockClass;
    },
    associateWineConfirm: function associateWineConfirm() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this5.$refs.confirm.open("Associate this wine", "Are you sure you want to associate this wine(".concat(_this5.wine.sku, ") ?"), {
                color: "red"
              });
            case 2:
              confirmed = _context.sent;
              if (confirmed) _this5.associateWine();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    associateWine: function associateWine() {
      this.$emit("associateWine", this.wine.id_wine);
    },
    associateCloneConfirm: function associateCloneConfirm() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var confirmed;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this6.$refs.confirm.open("Clone this wine and associate to supplier price.", "Are you sure you want to clone this wine(".concat(_this6.wine.sku, ") ?"), {
                color: "red"
              });
            case 2:
              confirmed = _context2.sent;
              if (confirmed) _this6.cloneWine();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    cloneWine: function cloneWine() {
      this.$emit("associateCloneWine", this.wine.id_wine);
    },
    displayPrice: displayPrice,
    isUserBuyerGroup: isUserBuyerGroup,
    isAdminNotConsultant: isAdminNotConsultant,
    isConsultantOrHolding: isConsultantOrHolding,
    isHolding: isHolding,
    isIndividual: isIndividual
  }
};